export function institutionDataTypePatcher(data) {
    const { institution } = data;
    const famlyPay = institution === null || institution === void 0 ? void 0 : institution.famlyPay;
    return {
        __typename: 'Institution',
        id: institution.institutionId,
        institutionId: institution.institutionId,
        title: institution.title,
        address: institution.address ? { __typename: 'InstitutionAddress', ...institution.address } : null,
        image: { __typename: 'InstitutionImage', ...institution.image },
        vat: institution.vat,
        identificationNumber: institution.identificationNumber,
        famlyPay: famlyPay
            ? {
                __typename: 'InstitutionFamlyPay',
                hasPermissionToManageFamlyPay: famlyPay.hasPermissionToManageFamlyPay,
                shouldShowDebtCollectionFamlyPayBanner: famlyPay.shouldShowDebtCollectionFamlyPayBanner,
                status: {
                    __typename: 'InstitutionFamlyPayStatus',
                    enabled: famlyPay.status.enabled,
                    eligible: famlyPay.status.eligible,
                    started: famlyPay.status.started,
                    verified: famlyPay.status.verified,
                    automaticPaymentsEnabled: famlyPay.status.automaticPaymentsEnabled,
                },
            }
            : undefined,
    };
}
